module.exports = __webpack_public_path__ + "img/usp-life-buoy.30839c7.svg";